import { default as InterstateMonthlyPayment } from './sections/MonthlyPayment.interstate';
import { default as InterstateAddons } from './sections/Addons.interstate';
import { default as FrontEndProfit } from './dealRecap/FrontEndProfit.interstate';
import { default as BackEndProfit } from './dealRecap/BackendProfit.interstate';
import { default as GrossProfit } from './dealRecap/GrossProfit.interstate';
import { default as InterstateTotalResidual } from './sections/TotalResidual.interstate';
import { default as InterstateTotalTax } from './sections/TotalTax.interstate';
import { default as InterstateLeaseTotalTax } from './sections/LeaseTotalTax.interstate';
import { default as InterstateMSRP } from './sections/MSRP.interstate';
import { default as InterstateDiscount } from './sections/Discount.interstate';
import { default as InterstateDealerDiscounts } from './sections/DealerDiscounts.interstate';
import { default as InterstateSellingPrice } from './sections/SellingPrice.interstate';
import { default as InterstateGrossCapCost } from './sections/GrossCapCost.interstate';
import { default as InterstateAdjCapCost } from './sections/AdjCapCost.interstate';
import { default as InterstateCashDown } from './sections/CashDown.interstate';
import { default as InterstateNetSellingPrice } from './sections/NetSellingPrice.interstate';
import { default as InterstateTermLength } from './sections/TermLength.interstate';
import { default as InterstateRebates } from './sections/Rebates.interstate';
import { default as InterstateNetTrade } from './sections/NetTrade.interstate';
import { default as InterstateTotalAmountDue } from './sections/TotalAmountDue.interstate';
import { default as InterstateAmountFinanced } from './sections/AmountFinanced.interstate';
import { default as InterstateTotalDueAtSigning } from './sections/TotalDueAtSigning.interstate';
import { default as InterstateAddsToCapCost } from './sections/AddsToCapCost.interstate';
import { default as InterstateCapCostReduction } from './sections/CapCostReduction.interstate';
import { default as InterstatePayment } from './sections/Payment.interstate';
import { default as InterstateAdjustedResidual } from './sections/AdjustedResidual.interstate';
import { default as InterstateDueAtSigningPaidBy } from './sections/DueAtSigningPaidBy.interstate';
import { default as InterstateDueAtSigning } from './sections/DueAtSigning.interstate';
import { default as InterstateCashDueFromCustomer } from './sections/CashDueFromCustomer.interstate';
import { default as InterstateInsufficientFunds } from './sections/InsufficientFunds.interstate';
import { default as InterstateAdjustedSellingPrice } from './sections/AdjustedSellingPrice.interstate';
import { default as InterstateBalloonPayment } from './sections/BalloonPayment.interstate';
import { default as InterstateDetails } from './sections/Details.interstate';
import { default as InterstateDealPulse } from './sections/DealPulse.interstate';
import { default as InterstateTrades } from './sections/trades/TradesWrapper';
import { default as InterstateTotalOfPayments } from './sections/TotalOfPayments.interstate';
import { default as InterstatePriorBalance } from './sections/PriorBalance.interstate';

export const InterstateDealSummarySections = {
    FrontEndProfit,
    BackEndProfit,
    GrossProfit,
    InterstateAddons,
    InterstateAddsToCapCost,
    InterstateAdjCapCost,
    InterstateCapCostReduction,
    InterstateCashDown,
    InterstateDiscount,
    InterstateDealerDiscounts,
    InterstateGrossCapCost,
    InterstateMonthlyPayment,
    InterstateMSRP,
    InterstateNetSellingPrice,
    InterstateNetTrade,
    InterstateRebates,
    InterstateSellingPrice,
    InterstateTermLength,
    InterstateTotalAmountDue,
    InterstateAmountFinanced,
    InterstateTotalDueAtSigning,
    InterstateTotalResidual,
    InterstateTotalTax,
    InterstateLeaseTotalTax,
    InterstatePayment,
    InterstateAdjustedResidual,
    InterstateDueAtSigning,
    InterstateDueAtSigningPaidBy,
    InterstateCashDueFromCustomer,
    InterstateInsufficientFunds,
    InterstateAdjustedSellingPrice,
    InterstateBalloonPayment,
    InterstateDetails,
    InterstateDealPulse,
    InterstateTrades,
    InterstateTotalOfPayments,
    InterstatePriorBalance
};
export * from './utils/transform';
// Selector-delta telemetry registrations (Rally US2040919). Kept as an
// explicit named export path so `dash.tsx` can side-effect-invoke the
// registration once at bootstrap without pulling in section components.
export * from './telemetry';
